(function (exports) {
  if (exports) {//esto permite importar este factory en backend
    exports.factory = factory();
    return
  }
  angular.module('pentaApp').factory("identification.factory", factory);
  factory.$inject = [];
  function factory() {
    return {
      validate: validate,
      validateDNI: validateDNI,
      validateCUIT: validateCUIT,
      validateCUIL: validateCUIL,
      validateRUT: validateRUT,
      validateCedulaNicaragua: validateCedulaNicaragua,
      validateCedulaCostaRica: validateCedulaCostaRica,
      validateCedulaHonduras: validateCedulaHonduras,
      validateCedulaPanama: validateCedulaPanama,
      validateCedulaRepublicaDominicana: validateCedulaRepublicaDominicana,
    }

    function validate(identificationType, identificationNumber) {
      if (!identificationType || !identificationNumber) return console.error('No se otorgó el tipo o el número de la identificación que se intenta validar')
      let passed //message no se usaba
      switch (identificationType) {
        case 'DNI':
          if (!validateDNI(identificationNumber)) {
            passed = false
            break;
          }
          passed = true
          break;
        case 'CUIT':
          if (!validateCUIT(identificationNumber)) {
            passed = false
            break;
          }
          passed = true
          break;
        case 'CUIL':
          if (!validateCUIL(identificationNumber)) {
            passed = false
            break;
          }
          passed = true
          break;
        case 'RUT':
          if (!validateRUT(identificationNumber)) {
            passed = false
            break;
          }
          passed = true
          break;
        case 'CEDULA-NICARAGUA': {
          if (!validateCedulaNicaragua(identificationNumber)) {
            passed = false
            break;
          }
          passed = true
          break;
        }
        case 'CEDULA-COSTA-RICA': {
          if (!validateCedulaCostaRica(identificationNumber)) {
            passed = false
            break;
          }
          passed = true
          break;
        }
        case 'CEDULA-HONDURAS': {
          if (!validateCedulaHonduras(identificationNumber)) {
            passed = false
            break;
          }
          passed = true
          break;
        }
        case "CEDULA-PANAMA": {
          if (!validateCedulaPanama(identificationNumber)) {
            passed = false
            break;
          }
          passed = true
          break;
        }
        case "CEDULA-REPUBLICA-DOMINICANA": {
          if (!validateCedulaRepublicaDominicana(identificationNumber)) {
            passed = false
            break;
          }
          passed = true
          break;
        }
        case 'CEDULA': {
          // Este tipo queda como deprecado/generico, pero se agregaron varios tipos de cédula con sus respectivas validaciones
          passed = true;
          break;
        }
      }
      return {
        passed: passed
      }
    }

    function validateDNI(identificationNumber) {
      if (!identificationNumber) return
      if (!/^(\d{7,8})$|^(\d{2}\.{1}\d{3}\.\d{3})$/.exec(identificationNumber)) return
      return true
    }

    function validateCUIT(identificationNumber) {
      if (!identificationNumber) return
      if (!/^(\b(30|33|34)\-{1}[0-9]{8}\-{1}[0-9]{1})$/.exec(identificationNumber)) return
      return true
    }

    function validateCUIL(identificationNumber) {
      if (!identificationNumber) return
      if (!/^(\b(20|23|24|27)\-{1}[0-9]{8}\-{1}[0-9]{1})$/.exec(identificationNumber)) return
      return true
    }

    function validateRUT(identificationNumber) {
      if (!identificationNumber) return
      if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.exec(identificationNumber)) return
      const rutSplit = identificationNumber.split('-');
      let number = rutSplit[0];
      let checkDigit = rutSplit[1];
      if (checkDigit === 'K') checkDigit = 'k';
      let M = 0, S = 1;
      for (; number; number = Math.floor(number / 10)) {
        S = (S + number % 10 * (9 - M++ % 6)) % 11;
      }
      var result = S ? (S - 1) : 'k';
      if (result.toString() !== checkDigit) return
      return true
    }

    function validateCedulaNicaragua(identificationNumber) {
      if (!identificationNumber) return false;
      if (!/^[0-9]{13}[A-Za-z]{1}$/.exec(identificationNumber)) return
      return true
    }

    function validateCedulaCostaRica(identificationNumber) {
      if (!identificationNumber) return false;
      const CR = new RegExp("^[1-9]\\d{8}$")
      return CR.test(identificationNumber)
    }

    function validateCedulaHonduras(identificationNumber) {
      if (!identificationNumber) return false;
      const HO = new RegExp("^\\d{13}$")
      return HO.test(identificationNumber)
    }

    function validateCedulaPanama(identificationNumber) {
      if (!identificationNumber) return false;
      const PA = new RegExp("^((PE|E|N)|([1-9]|1[0-3])(AV|PI)?)\\d{1,4}\\d{1,6}$")
      return PA.test(identificationNumber)
    }

    function validateCedulaRepublicaDominicana(identificationNumber) {
      if (!identificationNumber) return false;
      const RD = new RegExp("^\\d{11}$")
      return RD.test(identificationNumber)
    }
  }

})(typeof exports !== 'undefined' && exports)
